// Pure routing decision used by AuthCallback.tsx's Google OAuth success branch. Extracted so
// the destination logic (which pending-invite/role combination sends the user where) is
// unit-testable without a live OAuth round trip.

export type ProfileRole = 'school_admin' | 'instructor' | 'student' | 'drivetrack_admin' | null | undefined

export interface AuthCallbackRoutingParams {
  role: ProfileRole
  pendingInstructorInviteToken: string | null
  pendingStudentInviteToken: string | null
  urlRole: string | null
}

export function resolveAuthCallbackDestination(params: AuthCallbackRoutingParams): string {
  const { role, pendingInstructorInviteToken, pendingStudentInviteToken, urlRole } = params

  if (pendingInstructorInviteToken && role === 'instructor') return '/accept-instructor-invite'
  // A pending STUDENT invite token must route through select-role to actually be consumed via
  // accept-invite — same reasoning as Login.tsx's email/password path (studentLoginRouting.ts):
  // this also covers an existing, already-confirmed student accepting a SECOND instructor's
  // invitation, not only a brand-new Google sign-up.
  if (pendingStudentInviteToken && role === 'student') return '/auth/select-role?role=student'
  if (role === 'school_admin') return '/app/school'
  if (role === 'instructor')   return '/app/instructor'
  if (role === 'student')      return '/app/student'
  if (urlRole) return `/auth/select-role?role=${urlRole}`
  return '/auth/select-role'
}
